import { modes } from "../modes";
import { roles } from "../roles";

export const saasManagementPermissionProfiles = {
    MANAGE_TENANTS: {
        [modes.EDIT]: [roles.SAAS_MANAGER]
    },
   
}